import { createSelector } from '@ngrx/store';

import { selectFehHomebatteryState } from '../feh-homebattery.state';

export const selectHomebatteryCapacityState = createSelector(
  selectFehHomebatteryState,
  (state) => state['homebattery-capacity']
);

export const selectHomebatteryBatteryCapacity = createSelector(
  selectHomebatteryCapacityState,
  (state) => state.calculatedBatteryCapacity
);
